import Header from "@COMPONENTS/partners/pages/common/desktop/Header";
import {TLocalMain} from "@COMPONENTS/partners/types";
import * as style from "@COMPONENTS/style/partners/styles";
import useGlobalMenu, {GlobalMenu} from "@QUERIES/bff/global/useGlobalMenu";
import {getPartnerCodeSSR} from "@QUERIES/essential/code/usePartnerCode";
import {goodsAvailEventAsync} from "@QUERIES/prdt/goods/useGoodsOneAvailEvent";
import useGoodsPtnByMenu, {GoodsPtnByMenu} from "@QUERIES/prdt/goods/useGoodsPtnByMenu";
import {Noimage} from "@yb/ui/desktop/common/Noimage";
import {format} from "@yb/utils";
import {GetServerSidePropsContext} from "next";
import {useRouter} from "next/router";
import {useMemo} from "react";

type localMainType = {
	thisMenuInfo: GlobalMenu;
	LocMenu: Array<GlobalMenu>;
	TmaMenu: Array<GlobalMenu>;
};

const LocalMain = (props: TLocalMain) => {
	const {query, partnerCode} = props;
	const router = useRouter();

	/** 메뉴 카테고리 */
	const globalMenu = useGlobalMenu({
		dspTypeCd: "A",
		dspSid: "A000000",
		level: "1,2,3,4",
	}).data?.body;
	const {menuLv2List, menuLv3List} = globalMenu;
	const menuList = useMemo(() => [...menuLv2List, ...menuLv3List], [globalMenu]);
	const partnerGoodsFetch = useGoodsPtnByMenu(query.dspSid, partnerCode, {placeholderData: {body: []}});
	const partnerGoods = partnerGoodsFetch.data.body || [];

	const localMainMenuList: localMainType = useMemo(() => {
		const result = {
			thisMenuInfo: null,
			LocMenu: [],
			TmaMenu: [],
		};
		if (!menuList) return result;
		return menuList.reduce((acc, cur) => {
			const {dspSid, dspSidHi, gnbTypeCd, locTypeCd, homeYn} = cur;
			dspSid === query.dspSid && (acc.thisMenuInfo = cur);
			if (dspSidHi === query.dspSid) {
				gnbTypeCd === "T" && locTypeCd === "L" && homeYn === "Y" && acc.LocMenu.push(cur);
				gnbTypeCd === "T" && locTypeCd === "T" && homeYn === "Y" && acc.TmaMenu.push(cur);
			}
			return acc;
		}, result);
	}, [menuList]);

	const path = `/partners/${query.$partnerName}/localList`;

	const goDetail = async (product: GoodsPtnByMenu) => {
		try {
			const res = await goodsAvailEventAsync(product.goodsCd);
			const pathname = `/partners/${query.$partnerName}/detailPackage`;
			const detailPath = `${pathname}?menu=${query.menu}&dspSid=${product.dspSidHi}&goodsCd=${product.goodsCd}&evCd=${res.data.body.evCd}`;
			router.push(
				{
					pathname,
					query: {
						menu: query.menu,
						dspSid: product.dspSidHi,
						goodsCd: product.goodsCd,
						evCd: res.data.body.evCd,
						partnerCode,
					},
				},
				detailPath,
			);
		} catch (e) {
			console.log(e);
		}
	};

	return (
		<style.Wrap>
			{/* 헤더 */}
			<Header />
			{/* 지역 상품 링크 */}
			{localMainMenuList.LocMenu.length > 0 && (
				<section>
					<style.LocalmainTitle>{localMainMenuList.thisMenuInfo.dspNm} 지역 상품 바로가기</style.LocalmainTitle>
					<style.LocalList>
						{localMainMenuList.LocMenu.map((menu, index) => (
							<li key={index}>
								<a
									href="#"
									onClick={e => {
										e.preventDefault();
										router.push(
											{
												pathname: `${path}`,
												query: {partnerCode, menu: menu.dspMenu, dspSid: menu.dspSid},
											},
											`${path}?menu=${menu.dspMenu}&dspSid=${menu.dspSid}`,
										);
									}}
								>
									<span>{menu.dspNm}</span>
								</a>
							</li>
						))}
					</style.LocalList>
				</section>
			)}
			{/* 테마 상품 링크 */}
			{localMainMenuList.TmaMenu.length > 0 && (
				<section>
					<style.LocalmainTitle>내륙/섬 테마 상품 바로가기</style.LocalmainTitle>
					<style.LocalList>
						{localMainMenuList.TmaMenu.map((menu, index) => (
							<li key={index}>
								<a
									href="#"
									onClick={e => {
										e.preventDefault();
										router.push(`${path}?menu=${menu.dspMenu}&dspSid=${menu.dspSid}`);
									}}
								>
									<span>{menu.dspNm}</span>
								</a>
							</li>
						))}
					</style.LocalList>
				</section>
			)}
			{partnerGoods.length > 0 && (
				<section>
					<style.LocalmainTitle>{localMainMenuList.thisMenuInfo?.dspNm} BEST 예약 상품</style.LocalmainTitle>
					<style.ProductList>
						{partnerGoods
							.slice(0, 20)
							// eslint-disable-next-line no-nested-ternary
							.sort((a, b) => (a.minPrice > b.minPrice ? 1 : a.minPrice < b.minPrice ? -1 : 0))
							.map((product, index) => (
								<li key={index}>
									<a
										href="#"
										onClick={e => {
											e.preventDefault();
											goDetail(product);
										}}
									>
										<style.Thumbnail>
											<Noimage width="285px" height="195px" src={product.imageThum3} alt="상품 이미지" />
										</style.Thumbnail>
										<style.InfoBox>
											<h4>{product.goodsNm}</h4>
											<style.Pirice>
												<em>{format.koKRFormatNumber(product.minPrice)}</em> 원~
											</style.Pirice>
										</style.InfoBox>
									</a>
								</li>
							))}
					</style.ProductList>
				</section>
			)}
		</style.Wrap>
	);
};

export default LocalMain;

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
	const {query} = ctx;
	const getPartnerCode = await getPartnerCodeSSR(query.$partnerName as string);

	return {
		props: {
			query,
			partnerCode: getPartnerCode.data?.body?.commCdId || null,
		},
	};
}
